
        <div class="modal-header">
            <div class="title"> {{ 'PRODUCT.CREATE_RECORD_SHIPPING_PRODUCT' | translate }}</div>
        </div>

        <div class="modal-body">
            
            <form class="form" [formGroup]="form" autocomplete="off">

                <div class="col-12">
                    <div class="form-group">
                        <label for="product_id"><span class="star">*</span> {{ 'PRODUCT.PRODUCTS_LIST' | translate }}</label>
                        <ng-select 
                        id="product_id" 
                        class="custom" 
                        clearAllText="{{ 'CLEAR' | translate }}" 
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name" 
                        bindValue="id" 
                        formControlName="products_id"
                        placeholder="{{ 'PRODUCT.CHOOSE_PRODUCT' | translate }}"
                        [multiple]="true"
                        [loading]="loading" 
                        [closeOnSelect]="false"
                        [items]="products">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" />&nbsp;
                                    <span>{{item.name}}</span>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="errorMessages">
                            <div *ngFor="let item of errorMessages.products_id">
                                <div class="text-error" *ngIf="validation('products_id', item.type)">
                                    {{ item.message | translate: item.options }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </form>

        </div>

        <div class="modal-footer btn-box">
            <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()" [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
            <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
        </div>